var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('v-layout',{attrs:{"justify-center":""}},[_c('CreditCardAdd')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }